// extracted by mini-css-extract-plugin
module.exports = {"overflowContainer":"ContestPromoTile_overflowContainer__imjwy","contentContainer":"ContestPromoTile_contentContainer__MIM4V","imageWrapper":"ContestPromoTile_imageWrapper__gpmKP"};